document.addEventListener('DOMContentLoaded', () => {
    const filterButtons = document.querySelectorAll('.js-vacancy-filter');
    const vacancyCards = document.querySelectorAll('.js-vacancy-card');

    if (!filterButtons.length || !vacancyCards.length) {
        return;
    }

    filterButtons.forEach(button => {
        button.addEventListener('click', () => {
            const tag = button.dataset.tag;

            filterButtons.forEach(item => item.classList.remove('active'));
            button.classList.add('active');

            vacancyCards.forEach(card => {
                const tags = (card.dataset.vacancyTags || '')
                    .split(',')
                    .filter(Boolean);
                const shouldShow = tag === 'all' || tags.includes(tag);

                card.classList.toggle('hidden', !shouldShow);
            });
        });
    });
});
